/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionStateLookupTypeFromJSON, ApiConversionStateLookupTypeToJSON, } from './ApiConversionStateLookupType';
import { ApiConversionStateTriggerFromJSON, ApiConversionStateTriggerToJSON, } from './ApiConversionStateTrigger';
export function ApiConversionStateInputFromJSON(json) {
    return ApiConversionStateInputFromJSONTyped(json, false);
}
export function ApiConversionStateInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lookup': !exists(json, 'lookup') ? undefined : ApiConversionStateLookupTypeFromJSON(json['lookup']),
        'offline': !exists(json, 'offline') ? undefined : json['offline'],
        'offlineFieldName': !exists(json, 'offlineFieldName') ? undefined : json['offlineFieldName'],
        'preventSubmit': !exists(json, 'preventSubmit') ? undefined : json['preventSubmit'],
        'repeatedSelector': !exists(json, 'repeatedSelector') ? undefined : json['repeatedSelector'],
        'target': !exists(json, 'target') ? undefined : json['target'],
        'targetInnerText': !exists(json, 'targetInnerText') ? undefined : json['targetInnerText'],
        'trigger': !exists(json, 'trigger') ? undefined : ApiConversionStateTriggerFromJSON(json['trigger']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiConversionStateInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'lookup': ApiConversionStateLookupTypeToJSON(value.lookup),
        'offline': value.offline,
        'offlineFieldName': value.offlineFieldName,
        'preventSubmit': value.preventSubmit,
        'repeatedSelector': value.repeatedSelector,
        'target': value.target,
        'targetInnerText': value.targetInnerText,
        'trigger': ApiConversionStateTriggerToJSON(value.trigger),
        'value': value.value,
    };
}
